<template>
    <div id="best-practices-details-form" class="bp-detail grid-nogutter">
        <div class="col-12 flex grid-nogutter mb-2">
            <div class="field mr-2 mb-0">
                <div class="p-float-label">
                    <InputText type="text" v-model="v$.titre.$model"
                        :class="{ 'p-invalid': v$.titre.$invalid && submitted }" @change="onChange" />
                    <label>{{ $t("best_practices_form.title_field") }}</label>
                </div>
                <as-input-error :errors="v$.titre.$silentErrors" v-show="submitted" />
            </div>
            <div class="flex align-items">
                <img class="flag" :src="getFlag" />
                <ProgressSpinner strokeWidth="5" v-if="beingTranslated && currentIsoCodeLocale !== selectedLocale" />
                <Button v-if="!beingTranslated && currentIsoCodeLocale !== selectedLocale" :label="$t('form.translate')"
                    class="button-primary ml-2 flex-1" @click="translateTo" />
            </div>
        </div>

        <div class="col-12 grid-nogutter">
            <div class="field">
                <label>{{ $t("best_practices_form.description_field") }}</label>
                <div class="p-float-label">
                    <TinyMceEditor v-model="v$.description.$model" @update:modelValue="onEditorChange" />
                </div>
                <as-input-error :errors="v$.description.$silentErrors" v-show="submitted" />
            </div>
        </div>
    </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import TinyMceEditor from "@/components/Editor/TinyMceEditor.vue";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import ProgressSpinner from "primevue/progressspinner";
import AsInputError from "./AsInputError.vue";
import { mapGetters } from "vuex";
import { getTinyMceConfig } from "../../config/tinymce.config";

export default {
    components: {
        InputText,
        TinyMceEditor,
        AsInputError,
        Button,
        ProgressSpinner,
    },
    props: {
        detail: {
            type: Object,
            default: () => {
                return { titre: "", description: "", idLangue: 1 };
            },
        },
        submitted: Boolean,
        beingTranslated: Boolean,
    },
    setup() {
        return { v$: useVuelidate() };
    },
    watch: {
        detail: {
            handler(newDetail) {
                if (newDetail.titre !== this.titre) {
                    this.titre = newDetail.titre;
                    this.v$.titre.$model = newDetail.titre;
                }
                if (newDetail.description !== this.description) {
                    this.description = newDetail.description;
                    this.v$.description.$model = newDetail.description;
                }
            },
            deep: true
        }
    },
    data() {
        return {
            titre: this.detail.titre,
            description: this.detail.description,
            configTinyMce: getTinyMceConfig(
                this.translateToEditor
            ),
            currentIsoCodeLocale: "",
            selectedLocale: this.$i18n.locale,
        };
    },
    mounted() {
        this.currentIsoCodeLocale = this.getCurrentIsoCode();
    },
    validations() {
        return {
            titre: { required },
            description: { required },
        };
    },
    computed: {
        ...mapGetters({
            languages: "getLanguages",
        }),
        getFlag() {
            return new URL(`../../assets/images/flags/${this.getCurrentIsoCode()}.svg`, import.meta.url).href;
        },
    },
    emits: ["onChange", "onTranslate", "onTranslateToEditor"],
    methods: {
        onEditorChange(newValue) {
            this.description = newValue;
            this.onChange();
        },
        onChange() {
            this.$emit("onChange", {
                ...this.detail,
                titre: this.titre,
                description: this.description,
                idLangue: this.detail.idLangue,
            });
        },
        getCurrentIsoCode() {
            return this.languages.find((el) => el.id === this.detail.idLangue)
                .codeIso;
        },
        getLangue() {
            return this.languages.find(
                (el) => el.id === this.detail.idLangue
            );
        },

        translateTo() {
            this.$emit("onTranslate", this.getLangue());
        },

        translateToEditor() {
            this.$emit("onTranslateToEditor", this.getLangue());
        },
    },
};
</script>

<style lang="scss" scoped>
.flag {
    height: 40px;
}

.bp-detail .field {
    flex: 1;
}

#best-practices-details-form {
    .p-progress-spinner {
        height: 30px !important;
    }
}
</style>
